// rh-footer/rh-footer-universal.js
import { createComponent } from '@lit/react';
import react from 'react';
import { RhFooterUniversal } from '@rhds/elements/rh-footer/rh-footer-universal.js';
export const FooterUniversal = createComponent({
  tagName: 'rh-footer-universal',
  elementClass: RhFooterUniversal,
  react,
  events: {},
});
